export const VELA_THEME = 'velaTheme';

export const AFFILIATE = 'affiliate';

export const AFFILIATE_STATUS = 'affiliateStatus';

export const AFFILIATE_ANNOUNCEMENT_SEEN = 'affiliateAnnouncementSeen';

export const AFFILIATES_BANNER_SEEN = 'affiliatesBannerSeen';

export const ANNOUNCEMENT_BANNER_SEEN = 'announcementBannerSeen';

export const BILLING_V3_PLUS_PREFERRED = 'billingV3PlusPreferred';

export const ETSY_TAGS_GENERATE_HINT_SEEN = 'etsyTagsGenerateHintSeen';

export const FAIRE_INTRO_SEEN = 'faireIntroSeen';

export const INTRO_SEEN = 'introSeen';

export const VIP_INTRO_SEEN = 'vipIntroSeen';

export const COMMUNITY_MODAL_SEEN = 'communityModalSeen';

export const PROFILES_INTRO_SEEN = 'profilesIntroSeen';

export const SCHEDULE_INTRO_SEEN = 'scheduleIntroSeen';

export const TEMPLATE_MODE_INTRO_SEEN = 'templateModeIntroSeen';

export const WISHLIST_BANNER_SEEN = 'wishlistBannerSeen';

export const BETA_FEATURE = {
  AI_PROFILES: 'ai_profiles',
};
